import 'babel-polyfill';



// WEBPACK FOOTER //
// ./src/polyfills.js